<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-6"><a id="_idTextAnchor001"></a><a href="#/97808021888094#_idTextAnchor000">PROLOGUE</a></p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-2" src="image/HR_0.1.jpg"/>
</div>
</div>
<blockquote class="Caption">Frank “Peg Leg” Jones</blockquote>
<div class="_idGenObjectLayout-1">
<div id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-2" src="image/HR_0.2.jpg"/>
</div>
</div>
<p class="BT-CO"><span class="_idGenDropcap-1">H</span>ere are the histories of my parents and siblings whose often tragically shaped lives feed my music and personality. Here are the stories of my friends and lovers, co-writers and producers, and those demons and angels who wage a constant battle for my soul. There were cave dwellers, Southern hoodoo, urban jails, and some of the most opulent hotels in the world. I’ve traveled to these places via my thumb and VW bug and a few times, the Concorde supersonic jet. I’ve lived volumes as a young girl long before I was famous and here I share the largeness of events I experienced through my younger eyes. </p>
<p class="BT-space"><span class="CharOverride-2">I sense a natural language being whispered that is shared by all of us. After all these decades, life remains stubbornly mysterious. In dreams I sometimes understand the symbols, but then I wake up and they’re gone. A puff of ink that will not stick to this reality. What was I hearing? What were they saying? Was it music? Surely I heard </span><span class="CharOverride-4">something</span><span class="CharOverride-2">. After all these decades, life remains stubbornly mysterious. </span></p>
<p class="BT"><span class="CharOverride-2">Music shapes us and fundamentally changes us. Once we have listened we do not stop. We do not ever recover from music. We will return again and again to the radio, the record store, the bedroom where girls listen to records all day.</span></p>
<p class="BT"><span class="CharOverride-2">Performing is a religious experience for me. You can never know what I feel, only what you feel. My secret courage is my magic. You are doused with my strange water of emotion as you witness this courage, and that is my true performance. It sounds like music but something is being passed between us. Something personal. </span></p>
<p class="BT-space"><span class="CharOverride-2">I have come to believe that I am moving in the right direction, following a path more than forging the way. My performances center around that belief. I am propelled forward by seemingly random events linked together by the fact that eventually I end up in better circumstances than when I began. Sure, bad things happen but if I keep pushing to become my best self, I am brought from the pain into a brighter passage. That instinct—to believe in m</span><span class="CharOverride-2">y heart—always delivers me. I go where </span><span class="CharOverride-4">she </span><span class="CharOverride-2">is going. I’m with </span><span class="CharOverride-4">Her.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802188809-5.vue?4d756758